import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM';

export class LobbyRadio extends UcoastEl {
    static htmlSelector = 'lobby-radio'
    audio: HTMLAudioElement
    control: HTMLButtonElement
    timerWrapper: HTMLElement

    constructor() {
        super()
        this.audio = q.rs('audio', this)
        this.control = q.rs('.header__lobby-radio-control', this)
        this.timerWrapper = q.rs('.header__lobby-radio-timer', this)
        this.control.addEventListener('click', this.onClickControl.bind(this))
        this.audio.addEventListener('timeupdate', this.onTimeUpdate.bind(this))
        this.audio.addEventListener('ended', this.onEnded.bind(this))
    }

    addAnimation() {
        this.timerWrapper.classList.add('scroll-trigger', 'animate--fade-in')
        this.timerWrapper.addEventListener('animationend', () => {
            this.timerWrapper.classList.remove('scroll-trigger', 'animate--fade-in')
        }, { once: true });
    }

    onClickControl(e: Event) {
        e.preventDefault()
        if(this.classList.contains('playing')) {
            this.classList.remove('playing')
            this.audio.pause()
            setTimeout(() => {
                this.timerWrapper.textContent = this.timerWrapper.dataset.text || ''
                this.addAnimation()
            }, 50)
        } else {
            this.classList.add('playing')
            this.audio.play()
            setTimeout(() => {
                this.addAnimation()
            }, 150);
        }
    }

    onTimeUpdate(e: Event) {
        const currentTime = Math.floor(this.audio.currentTime)
        const duration = Math.floor(this.audio.duration)
        this.timerWrapper.textContent = this.timeFormat(currentTime) + ' / ' + this.timeFormat(duration)
    }

    onEnded(e: Event) {
        this.classList.remove('playing')
        setTimeout(() => {
            this.timerWrapper.textContent = this.timerWrapper.dataset.text || ''
            this.addAnimation()
        }, 50)
    }

    timeFormat(timeInSeconds: number) {
        const minutes = Math.floor(timeInSeconds / 60).toString().padStart(2, '0');
        const seconds = (timeInSeconds % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
    }
}
